import _createForOfIteratorHelper from "D:/git/aexdo_frontend_local/aexdo_frontend/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";

/** These methods may break the react binding if called directly */
var skipMethods = ['setMaxBounds', 'setMinZoom', 'setMaxZoom', 'setMinPitch', 'setMaxPitch', 'setRenderWorldCopies', 'setProjection', 'setStyle', 'addSource', 'removeSource', 'addLayer', 'removeLayer', 'setLayerZoomRange', 'setFilter', 'setPaintProperty', 'setLayoutProperty', 'setLight', 'setTerrain', 'setFog', 'remove'];
export default function createRef(mapInstance, mapLib) {
  if (!mapInstance) {
    return null;
  }

  var map = mapInstance.map;
  var result = {
    getMap: function getMap() {
      return map;
    },
    // Overwrite getters to use our shadow transform
    getCenter: function getCenter() {
      return mapInstance.transform.center;
    },
    getZoom: function getZoom() {
      return mapInstance.transform.zoom;
    },
    getBearing: function getBearing() {
      return mapInstance.transform.bearing;
    },
    getPitch: function getPitch() {
      return mapInstance.transform.pitch;
    },
    getPadding: function getPadding() {
      return mapInstance.transform.padding;
    },
    getBounds: function getBounds() {
      return mapInstance.transform.getBounds();
    },
    project: function project(lnglat) {
      return mapInstance.transform.locationPoint(mapLib.LngLat.convert(lnglat));
    },
    unproject: function unproject(point) {
      return mapInstance.transform.pointLocation(mapLib.Point.convert(point));
    },
    queryTerrainElevation: function queryTerrainElevation(lnglat, options) {
      // @ts-ignore transform not defined
      var tr = map.transform; // @ts-ignore transform not defined

      map.transform = mapInstance.transform;
      var result = map.queryTerrainElevation(lnglat, options); // @ts-ignore transform not defined

      map.transform = tr;
      return result;
    }
  };

  var _iterator = _createForOfIteratorHelper(getMethodNames(map)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;

      // @ts-expect-error
      if (!(key in result) && !skipMethods.includes(key)) {
        result[key] = map[key].bind(map);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}

function getMethodNames(obj) {
  var result = new Set();
  var proto = obj;

  while (proto) {
    var _iterator2 = _createForOfIteratorHelper(Object.getOwnPropertyNames(proto)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var key = _step2.value;

        if (key[0] !== '_' && typeof obj[key] === 'function' && key !== 'fire' && key !== 'setEventedParent') {
          result.add(key);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    proto = Object.getPrototypeOf(proto);
  }

  return Array.from(result);
}